export default __webpack_public_path__ + "static/media/logo-bsc_mobile.4adf9e91.svg";